import AdminLanding from '../AdminLanding';
import { UserList, User, TenantList, Tenant, Management, AdminLogs,
         ScreenDefinitions, ObjectList, ObjectScreen, GlobalObjectList, GlobalObjectScreen,
         EmailTemplateList, EmailTemplate, EmailSentList,
         EmailSent, QueueJobs, QueueJob, DataUploadList,
         DataUpload, AnnouncementList, Announcement,
         DispensaryList, Dispensary, HealthDashboard, ComplianceEvidence,
         HelpLinks, HelpLinkEntry, GuideAdministration } from './Components';

const adminRoutes = [
    { 
        exact: true, 
        path: "/admin", 
        name: "Admin Dashboard", 
        Component: AdminLanding, 
        navMenu: { 
            category: "admin", 
            index: "dashboard", 
            screenDef: 'Admin' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { exact: false, path: '/announcements', name: 'Announcements', Component: AnnouncementList, navMenu: { category: "config", index: "announcements" }, auth: { required: true, internal: true }},
    { exact: true, path: '/announcement', name: 'Announcement', Component: Announcement, navMenu: { category: "config", index: "announcements" }, auth: { required: true, internal: true }},
    { exact: true, path: '/announcement/:id', name: 'Announcement', Component: Announcement, navMenu: { category: "config", index: "announcements" }, auth: { required: true, internal: true }},
    { 
        exact: false, 
        path: "/users", 
        name: "User List", 
        Component: UserList, 
        navMenu: { 
            category: "config", 
            index: "users", 
            screenDef: 'UserList' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: true, 
        path: "/user/:id", 
        name: "User", 
        Component: User, 
        navMenu: { 
            category: "config", 
            index: "users", 
            screenDef: 'User' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: true, 
        path: "/user", 
        name: "User", 
        Component: User, 
        navMenu: { 
            category: "config", 
            index: "users", 
            screenDef: 'User' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: false, 
        path: "/tenants", 
        name: "Tenant List", 
        Component: TenantList, 
        navMenu: { 
            category: "config", 
            index: "tenants", 
            screenDef: 'TenantList' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: true, 
        path: "/tenant/:id", 
        name: "Tenant", 
        Component: Tenant, 
        navMenu: { 
            category: "config", 
            index: "tenants", 
            screenDef: 'Tenant' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: true, 
        path: "/tenant", 
        name: "Tenant", 
        Component: Tenant, 
        navMenu: { 
            category: "config", 
            index: "tenants", 
            screenDef: 'Tenant' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: false, 
        path: "/management", 
        name: "Management", 
        Component: Management, 
        navMenu: { 
            category: "config", 
            index: "management", 
            screenDef: 'Management' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: false, 
        path: "/objects", 
        name: "Objects", 
        Component: ObjectList, 
        navMenu: { 
            category: "config", 
            index: "objects", 
            screenDef: 'Objects' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: false, 
        path: "/object/:id", 
        name: "Object", 
        Component: ObjectScreen, 
        navMenu: { 
            category: "config", 
            index: "objects", 
            screenDef: 'ObjectScreen' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    {
        exact: false,
        path: '/globalobjects',
        name: 'Global Objects',
        Component: GlobalObjectList,
        navMenu: {
            category: 'config',
            index: 'globalobjects',
            screenDef: 'GlobalObjects'
        },
        auth: {
            required: true,
            internal: true
        }
    },
    {
        exact: true,
        path: '/globalobject',
        name: 'Global Object',
        Component: GlobalObjectScreen,
        navMenu: {
            category: 'config',
            index: 'globalobjects',
            screenDef: 'GlobalObjectScreen'
        },
        auth: {
            required: true,
            internal: true
        }
    },
    {
        exact: true,
        path: '/globalobject/:id',
        name: 'Global Object',
        Component: GlobalObjectScreen,
        navMenu: {
            category: 'config',
            index: 'globalobjects',
            screenDef: 'GlobalObjectScreen'
        },
        auth: {
            required: true,
            internal: true
        }
    },
    { 
        exact: false, 
        path: "/emailtemplates", 
        name: "Email Templates", 
        Component: EmailTemplateList, 
        navMenu: { 
            category: "config", 
            index: "emailtemplates", 
            screenDef: 'EmailTemplateList' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: true, 
        path: "/emailtemplate/:id", 
        name: "Email Template", 
        Component: EmailTemplate, 
        navMenu: { 
            category: "config", 
            index: "emailtemplates", 
            screenDef: 'EmailTemplate' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: true, 
        path: "/emailtemplate", 
        name: "Email Template", 
        Component: EmailTemplate, 
        navMenu: { 
            category: "config", 
            index: "emailtemplates", 
            screenDef: 'EmailTemplate' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: false, 
        path: "/emailssent", 
        name: "Sent Emails", 
        Component: EmailSentList, 
        navMenu: { 
            category: "config", 
            index: "emailssent", 
            screenDef: 'EmailSentList' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: true, 
        path: "/emailsent/:id", 
        name: "Sent Email", 
        Component: EmailSent, 
        navMenu: { 
            category: "config", 
            index: "emailssent", 
            screenDef: 'EmailSent' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: false, 
        path: "/queuejobs", 
        name: "Queue Jobs", 
        Component: QueueJobs, 
        navMenu: { 
            category: "config", 
            index: "queueJobs" 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: true, 
        path: "/queuejob/:id", 
        name: "Queue Job", 
        Component: QueueJob, 
        navMenu: { 
            category: "config", 
            index: "queueJobs" 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: true, 
        path: "/queuejob", 
        name: "Queue Job", 
        Component: QueueJob, 
        navMenu: { 
            category: "config", 
            index: "queueJobs" 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: false, 
        path: "/datauploads", 
        name: "Data Uploads", 
        Component: DataUploadList, 
        navMenu: { 
            category: "config", 
            index: "dataUpload", 
            screenDef: 'dataUploads' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: true, 
        path: "/dataupload/:id", 
        name: "Data Upload", 
        Component: DataUpload, 
        navMenu: { 
            category: "config", 
            index: "dataUpload", 
            screenDef: 'DataUpload' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { 
        exact: true, 
        path: "/dataupload", 
        name: "Data Upload", 
        Component: DataUpload, 
        navMenu: { 
            category: "config", 
            index: "dataUpload", 
            screenDef: 'DataUpload' 
        }, 
        auth: { 
            required: true, 
            internal: true 
        }
    },
    { exact: false, path: '/screendefinitions', name: 'Screen Definitions', Component: ScreenDefinitions, navMenu: { category: "config", index: "screendefinitions", screenDef: 'ScreenDefinitions' }, auth: { required: true, internal: true }},
    { exact: false, path: '/logs', name: 'Logs', Component: AdminLogs, navMenu: { category: "config", index: "adminlogs", screenDef: 'AdminLogs' }, auth: { required: true, internal: true }},
    { exact: false, path: '/dispensaries', name: 'Dispensaries', Component: DispensaryList, navMenu: { category: "config", index: "dispensaries", screenDef: 'DispensaryList' }, auth: { required: true, internal: true }},
    { exact: true, path: '/dispensary/:id', name: 'Dispensary', Component: Dispensary, navMenu: { category: "config", index: "dispensaries", screenDef: 'Dispensary' }, auth: { required: true, internal: true }},
    { exact: false, path: '/healthdashboard', name: 'System Health', Component: HealthDashboard, navMenu: { category: "admin", index: "healthdashboard", screenDef: 'HealthDashboard' }, auth: { required: true, internal: true }},
    { exact: false, path: '/complianceevidence', name: 'Compliance Evidence', Component: ComplianceEvidence, navMenu: { category: "admin", index: "complianceevidence", screenDef: 'ComplianceEvidence' }, auth: { required: true, internal: true }},
    { exact: true, path: '/helplinks', name: 'Help Links', Component: HelpLinks, navMenu: { category: "config", index: "helplinks", screenDef: 'HelpLinks' }, auth: { required: true, internal: true }},
    { exact: true, path: '/helplink', name: 'Help Link', Component: HelpLinkEntry, navMenu: { category: "config", index: "helplinks", screenDef: 'HelpLink' }, auth: { required: true, internal: true }},
    { exact: true, path: '/helplink/:id', name: 'Help Link', Component: HelpLinkEntry, navMenu: { category: "config", index: "helplinks", screenDef: 'HelpLink' }, auth: { required: true, internal: true }},
    { exact: false, path: '/guides', name: 'Guide Administration', Component: GuideAdministration, navMenu: { category: "config", index: "guides", screenDef: 'GuideAdministration' }, auth: { required: true, internal: true }},
    { exact: true, path: '/guide', name: 'Guide', Component: GuideAdministration, navMenu: { category: "config", index: "guides", screenDef: 'GuideAdministration' }, auth: { required: true, internal: true }},
    { exact: true, path: '/guide/:id', name: 'Guide', Component: GuideAdministration, navMenu: { category: "config", index: "guides", screenDef: 'GuideAdministration' }, auth: { required: true, internal: true }}
];

export default adminRoutes;